import { CSSProperties } from 'react';
import { Popper, styled, SxProps } from 'components/base';
import { secondary } from 'assets/colors';

export const valueStyles: CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '100% !important',
};

export const StyledPopper = styled(Popper)(() => ({
  zIndex: '999999 !important',
  '& .MuiAutocomplete-option': {
    paddingTop: '6px !important',
    paddingBottom: '6px !important',
  },
}));

export const ListGroupHeaderStyles: SxProps = {
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  bgcolor: 'background.paper',
  padding: '16px 10px',
};

export const createableButtonStyles: SxProps = {
  display: 'flex !important',
  justifyContent: 'flex-start !important',
  py: '12px !important',
  '&:hover': {
    backgroundColor: `${secondary.background} !important`,
  },
};
